import { ActionTypes } from "./constants";

const doToggleLoadingScreen = () =>({ type: ActionTypes.DO_TOGGLE_LOADING_SCREEN });
const doFormSubmitLoading = () =>({ type: ActionTypes.DO_FORM_SUBMIT_LOADING });
const setPath = (path) =>({ type: ActionTypes.SET_PATH, payload: path });

const exports = { 
    doToggleLoadingScreen,
    doFormSubmitLoading,
    setPath
}

export default exports
